import { connect } from "react-redux";


import * as modal from "../../reducers/modalReducer";
import { invalidateUser } from "../../reducers/userReducer";
import GenericModal from "./GenericModal";

const mapStateToProps = state => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideModal: () => dispatch(modal.hideModal()),
    openSignUpForm: () =>
      dispatch(
        modal.openModal({
          modalType: "SIGNUP_FORM",
          modalProps: {}
        })
      ),
    go: path => dispatch(pushWithQueryParams(path)),
    invalidate: () => dispatch(invalidateUser())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);



// WEBPACK FOOTER //
// ./src/components/GenericModal/GenericModal_container.jsx